import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';

import { commaFormatNumber } from '@Utils/String';

import RxSpinnerComponent from '@Components/Results/utils/rx-spinner.component';
import { Checkbox } from '@els/els-react--checkbox';
// eslint-disable-next-line import/no-named-as-default, import/no-named-as-default-member
import HtmlStripsService from '@Services/HtmlStripsService';

import './ActiveChunk.custom.scss';
import './ActiveChunk.theme.scss';

const spinnerId = 'ActiveChunkSpinner';

function ActiveChunk(props) {
  const { activeChunk, onCheckboxClick } = props;

  if (!activeChunk) {
    return (
      <div className="bar-chart-checkboxes-dialog-active-chunk-wrapper">
        <div className="bar-chart-checkboxes-dialog-active-chunk">
          <RxSpinnerComponent autoStart spinnerId={spinnerId} />
        </div>
      </div>
    );
  }

  return (
    <div className="bar-chart-checkboxes-dialog-active-chunk-wrapper">
      <div className="bar-chart-checkboxes-dialog-active-chunk">
        {activeChunk.map((item) => {
          const title = HtmlStripsService.getTitleWithoutHtml(item.get('title'), 'stripexceptions');
          const id = item.get('id');
          const size = item.get('size');
          const selected = item.get('selected');
          // an item with 'no entry given' title always has a size bigger than maxSize, so percentages can be more than 100%

          return (
            <div
              key={id}
              className="bar-chart-checkboxes-dialog-active-chunk-item u-els-padding-top-1o2 u-els-padding-bottom-1o2 u-els-padding-right">
              <div>
                <Checkbox
                  key={title}
                  checked={selected}
                  onChange={() => {
                    onCheckboxClick(id, selected);
                  }}
                  label={title}
                  aria-checked={selected}
                />
              </div>
              <div>{commaFormatNumber(size)}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

ActiveChunk.propTypes = {
  activeChunk: PropTypes.instanceOf(List),
  onCheckboxClick: PropTypes.func.isRequired,
};

export default ActiveChunk;
